import React from 'react'

import BuildConfig from '$extensionSrc/buildConfig'
import ActionButton, {
  ActionButtonSize,
  ActionButtonType,
} from '$extensionSrc/components/ActionButton'

import './Enroll2faAppForm.scss'

function formatCode(totpCode: string): string {
  let formattedString = ''
  let curSegment = ''
  for (let i = 0; i < totpCode.length; i += 1) {
    curSegment += totpCode[i]
    if (curSegment.length === 4) {
      formattedString += `${curSegment} `
      curSegment = ''
    }
  }

  formattedString += curSegment

  return formattedString
}

export default function Enroll2faAppForm({
  onClickConfirm,
  onClickSkip,
  showSkip,
  totpCode,
  totpQrcode,
}: {
  onClickConfirm: () => void
  onClickSkip?: () => void
  showSkip: boolean
  totpCode?: string
  totpQrcode?: string
}) {
  const formattedCode = totpCode ? formatCode(totpCode) : ''
  return (
    <div className="Enroll2faAppForm">
      <div className="enroll-app-content">
        <div className="body1">
          In your authenticator app, scan the <strong>QR code</strong> to
          connect {BuildConfig.TENANT_NAME}.
          <br />
          <br />
          Or enter the code:
          <br />
          <strong>{formattedCode}</strong>
        </div>
        <div className="content-qrcode">
          <img alt="QR Code" className="qrcode" src={totpQrcode} />
        </div>
      </div>
      <div className="buttons">
        <ActionButton
          onClick={onClickConfirm}
          type={ActionButtonType.PRIMARY}
          size={ActionButtonSize.LARGE}
        >
          I connected the app
        </ActionButton>
        {showSkip && (
          <ActionButton
            onClick={onClickSkip}
            type={ActionButtonType.TERTIARY}
            size={ActionButtonSize.MEDIUM}
          >
            Skip for now
          </ActionButton>
        )}
      </div>
    </div>
  )
}
